import i18n from '@dms/i18n';

import {FluidReplacementServiceIntervals} from '../../core/types/RentalVehicle';
import {Field} from './primitives/Field';

interface LastFluidReplacementMileageInputProps {
  name: FluidReplacementServiceIntervals;
}

/**
 * Numeric input component for entering the mileage at which a vehicle fluid was last replaced.
 * Used in service interval tracking to record the vehicle's mileage when a fluid was last replaced.
 * This field does not trigger automatic calculations.
 *
 * @param props.name - The fluid name (e.g., 'brakeFluid', 'coolantFluid')
 */
export function LastFluidReplacementMileageInput(props: LastFluidReplacementMileageInputProps) {
  return (
    <Field
      type="number"
      name={`serviceIntervals.${props.name}.lastReplacementMileage`}
      label={i18n.t('entity.vehicle.labels.mileageAtLastReplacement')}
      suffix={i18n.t('general.metric.km')}
    />
  );
}
